<ng-container *ngIf="selectedProductVariantToShow.length">
    <div class="sub-product-variant-wrapper">
        <div class="row bg-white border-radius-6px">
            <div class="col-sm-9 col-xs-12 sub-product-variant-content">
                <div class="row d-flex align-items-center">
                    <ng-container *ngFor="let item of selectedProductVariantToShow; let i=index">
                        <div class="col-sm-4 col-xs-6 mt-4 mb-1 ml-2 d-flex justify-content-center sub-product-category-wrapper">
                            <div class="d-flex">
                                <p class="product-name">{{item.product}}</p>
                                <small class="font-weight-bold ml-1" *ngIf="item.category">{{item.category}}</small>
                                <ng-container *ngIf="isShowPercentage;else normalValueView">
                                    <span class="product-value mx-4">{{ item.value | number : '1.2-2'}} %</span>
                                </ng-container>
                                <ng-template #normalValueView>
                                    <span class="product-value mx-4">{{ item.value | number : '1.2-2'}}</span>
                                </ng-template>
                            </div>
                        </div>
                        <ng-container *ngIf="!(selectedProductVariantToShow.length-1 == i)">
                            <span class="text-color-light-grey">|</span>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
            <div class="col-sm-3 col-xs-12 mt-4 mb-sm-0 mb-4 mb-0 d-flex justify-content-sm-around justify-content-end align-items-center pr-sm-0 product-sub-product-footer">
                <a href="javascript:void(0);" (click)="knowMoreHandler()">{{ isLoading ? 'Loading...' : 'know more' }}</a>
                <i class="fa fa-times-circle cursor-pointer pl-sm-0 pl-5 big-text opacity-point-3 close-icon" aria-hidden="true" (click)="handleCloseProductVariant()"></i>
            </div>
        </div>
    </div>
</ng-container>
